import React, { useState, useEffect, useMemo } from "react";
import { Grid, Divider, Avatar } from "@mui/material";
import { toast } from "react-toastify";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { IoSearchOutline, IoCheckmarkCircleOutline } from "react-icons/io5";
import { FiCalendar } from "react-icons/fi";
import { FaFileCsv } from "react-icons/fa6";
import { LuRefreshCcw } from "react-icons/lu";
import { CiCircleQuestion } from "react-icons/ci";
import { BiSolidPhone } from "react-icons/bi";
import PiewithScrollableLegend from "../../Components/Charts/PiewithScrollableLegend";
import { GreenColorButton, PrimeGrayColorButton, StatusStyle, PrimeGrayBorderColorButton, DarkGreenColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import { StyledTableCell, StyledTableRow, CustomTablePagination } from "../../Components/MaterialTableStyle/MaterialTableStyle";
import { FormatDateMonth,OnlyDateTimeConverter, FormatDate } from "../../Components/Helpers/DateTimeConverter";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import CustomModal from "../../Components/Modal/CustomModal";
import DateRangeSelector from "../../Components/DateRangeSelector/DateRange";
import CustomDateInput from "../../Components/CustomInputs/CustomDateInput";
import { TabCustom, TabsCustom } from "../../Components/Tabs/CustomTabs";
import { FormatAmount } from "../../Components/Formatters/AmountFormat";
import { FormatNigerianPhoneNumber } from "../../Components/Formatters/PhoneNumberFormatter";
import { BaseAddressInfo, RecruitAdminDatas, FieldAgentSupervisorDatas, FieldAgentDataEntryDatas, FieldAgentDataVerificationDatas } from "../Team/Datas/Data";
import CorrectIcon from "../../Assets/Images/Logos/CorrectIcon.svg";
import InActiveIcon from "../../Assets/Images/Logos/InActiveIcon.svg";
import { CsvDownload } from "../../Components/CsvDownloader/CsvDownloader";

const Team = () => {

  const statics7dayData = { recruitadmins: 145, fieldagentsupervisors: 24, fieldagents: 50, totalapplicants: 78, finalizedapplicants: 30 };
  const staticsdayData = { recruitadmins: 145, fieldagentsupervisors: 24, fieldagents: 50, totalapplicants: 78, finalizedapplicants: 30 };
  const [tabValue, setTabValue] = useState(0);
  const [tabName, setTabName] = useState("");
  const [staticsInfo, setStaticsInfo] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [teamsDatas, setTeamsDatas] = useState([]);
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [sureName, setSureName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [baseAddress, setBaseAddress] = useState("");
  const [profileState, setProfileState] = useState("");
  const [profileCity, setProfileCity] = useState("");
  const [sucessModal, setSuccessModal] = useState(false);
  const [fieldagentChatDropdown, setFieldagentChatDropdown] = useState("");
  const [addProfileModal, setAddProfileModal] = useState(false);
  const [addSureName, setAddSureName] = useState("");
  const [addLastName, setAddLastName] = useState("");
  const [addEmail, setAddEmail] = useState("");
  const [addPhoneNumber, setAddPhoneNumber] = useState("");
  const [addBaseAddress, setAddBaseAddress] = useState("");
  const [addProfileState, setAddProfileState] = useState("");
  const [addProfileCity, setAddProfileCity] = useState("");
  const [addSucessModal, setAddSuccessModal] = useState(false);
  const [legendDatas, setLegendDatas] = useState([]);
  const [showCalendar, setShowCalender] = useState(false);
  const [calender, setCalender] = useState(null);
  const [dateRange, setDateRange] = useState("")
  const [filtersDate, setFiltersDate] = useState("");

  const CenterDatas = ["30%", "50%"]

  const legendData = [
    "Katsina",
    "Taraba",
    "Delta",
    "Edo",
    "Adamawa",
    "Kogi",
    "Lagos",
    "Osun",
    "Abuja",
    "Anambra",
    "Yobe"
  ];

  const legendData1 = [
    "Katsina",
    "Taraba",
    "Delta",
    "Edo",
    "Adamawa",
  ];

  const legendData2 = [
    "Kogi",
    "Lagos",
    "Osun",
    "Abuja",
    "Anambra",
    "Yobe"
  ];
  const FieldAgentsOptions = [
    {
      value: "All Field Agents",
      label: "All Field Agents",
    },
    {
      value: "Field Agent - Data Entry",
      label: "Field Agent - Data Entry"
    },
    {
      value: "Field Agent - Verification",
      label: "Field Agent - Verification"
    }
  ]

  const HandleFieldAgentChartDatas = (e) => {
    if (e == "Field Agent - Data Entry") {
      setFieldagentChatDropdown(e);
      setLegendDatas(legendData1);
    }
    else if (e == "Field Agent - Verification") {
      setFieldagentChatDropdown(e);
      setLegendDatas(legendData2);
    }
    else {
      setFieldagentChatDropdown(e);
      setLegendDatas(legendData);
    }
  }

  const seriesData = [];
  for (let i = 0; i < legendData?.length; i++) {
    seriesData.push({
      name: legendData[i],
      value: Math.round(Math.random() * 100000),
    });
  }

  const HandleMap = (row) => {
    setSureName(row?.userName);
    setLastName(row?.userName);
    setEmail(row?.email);
    setPhoneNumber(Number("741941234"));
    setBaseAddress(row.baseAddress);
    setProfileState(row?.state);
    setProfileCity(row.city);
    setEditProfileModal(true);
  }

  const HandleCloseModal = () => {
    setAddSureName("");
    setAddLastName("");
    setAddEmail("");
    setAddPhoneNumber("");
    setAddBaseAddress("");
    setAddProfileState("");
    setAddProfileCity("");
    setAddProfileModal(false);
  }

  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };

  const HandleAddProfile = () => {
    try {
      if (!addSureName) {
        toast.warn("Enter the Sure Name");
        return;
      }
      if (!addLastName) {
        toast.warn("Enter the Last Name");
        return;
      }
      if (!addEmail) {
        toast.warn("Enter Valid Email");
        return;
      }
      if (!ValidationEmails(addEmail)) {
        toast.warn("Invalid Email Entered");
        return;
      }
      if (!addPhoneNumber) {
        toast.warn("Enter the Phone Number");
        return;
      }
      if (!addBaseAddress) {
        toast.warn("Select your Base Address");
        return;
      }
      if (!addProfileState) {
        toast.warn("Enter your State");
        return;
      }
      if (!addProfileCity) {
        toast.warn("Select your City");
        return;
      }
      setAddProfileModal(false);
      setAddSuccessModal(true);
    }
    catch (err) {
      console.log("err in HandleUpdateProfile", err);
    }
  }

  const HandleAddSuccessModal = () => {
    setAddSuccessModal(false);
    toast.success(`${tabName} Added Sucessfully`);
  }

  const HandleUpdateProfile = () => {
    try {
      if (!sureName) {
        toast.warn("Enter the Sure Name");
        return;
      }
      if (!lastName) {
        toast.warn("Enter the Last Name");
        return;
      }
      if (!phoneNumber) {
        toast.warn("Enter the Phone Number");
        return;
      }
      if (!baseAddress) {
        toast.warn("Select your Base Address");
        return;
      }
      if (!profileState) {
        toast.warn("Enter your State");
        return;
      }
      if (!profileCity) {
        toast.warn("Select your City");
        return;
      }
      setEditProfileModal(false);
      setSuccessModal(true);
    }
    catch (err) {
      console.log("err in HandleUpdateProfile", err);
    }
  }

  const HandleSuccessModal = () => {
    setSuccessModal(false);
    toast.success(`${tabName} Updated Sucessfully`);
  }

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const HandleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const HandleTableChange = (event, newValue) => {
    if (newValue == 0) {
      setTabValue(newValue);
      setTabName("Recruit Admin");
      setTeamsDatas(RecruitAdminDatas);
      HandleRefresh();
    }
    else if (newValue == 1) {
      setTabValue(newValue);
      setTabName("Field Agent Supervisor");
      setTeamsDatas(FieldAgentSupervisorDatas);
      HandleRefresh();
    }
    else if (newValue == 2) {
      setTabValue(newValue);
      setTabName("Field Agent - Data Entry");
      setTeamsDatas(FieldAgentDataEntryDatas);
      HandleRefresh();
    }
    else if (newValue == 3) {
      setTabValue(newValue);
      setTabName("Field Agent - Verification");
      setTeamsDatas(FieldAgentDataVerificationDatas);
      HandleRefresh();
    }
    else {
      setTabValue(newValue);
      setTabName("Recruit Admin");
      setTeamsDatas(RecruitAdminDatas);
      HandleRefresh();
    }
  }

  const [filters, setFilters] = useState({
    state: null,
    city: null,
    status: null,
  });

  const stateOptions = useMemo(() => {
    const states = [
      ...new Set(
        teamsDatas.map((item) => item.state)
      ),
    ];
    return states.map((state) => ({ value: state, label: state }));
  }, [teamsDatas]);

  const cityOptions = useMemo(() => {
    const cities = [
      ...new Set(
        teamsDatas.map((item) => item.city)
      ),
    ];
    return cities.map((city) => ({ value: city, label: city }));
  }, [teamsDatas]);

  const statusOptions = useMemo(() => {
    const statuses = [...new Set(teamsDatas.map((item) => item.status))];
    return statuses.map((status) => ({ value: status, label: status }));
  }, [teamsDatas]);

  const HandleSelected = (filterKey, selectedOption) => {
    setFilters((prev) => ({
      ...prev,
      [filterKey]: selectedOption ? selectedOption.value : null,
    }));
  };

  const HandleRefresh = () => {
    setSearchTerm("");
    setFilters({
      state: null,
      city: null,
      status: null,
    });
    setDateRange("");
    setFiltersDate("");
    setShowCalender(false);
  };

  const GetDateFormat = () => {
    if (calender) {
      const FormatStartDate = FormatDateMonth(calender.startDate);
      const FormatEndDate = FormatDateMonth(calender.endDate);
      var Date = FormatStartDate + " To " + FormatEndDate;
      setFiltersDate((prev) => ({
        ...prev,
        startDate: calender.startDate.getTime(),
        endDate: calender.endDate.getTime(),
      }));
      setDateRange(Date);
      setShowCalender(false);
    }
  };

  const filteredAdmins = useMemo(() => {
    setPage(0);
    return teamsDatas.filter((item) => {
      const AddedOn = item.addedOn;
      if (filtersDate.startDate && filtersDate.endDate) {
        return (AddedOn <= filtersDate.endDate && AddedOn >= filtersDate.startDate);
      }
      return (
        (!filters.city || item.city === filters.city) &&
        (!filters.state || item.state === filters.state) &&
        (!filters.status || item.status === filters.status) &&
        (searchTerm === "" ||
          item.userName.toLowerCase().includes(searchTerm.toLowerCase()) || item.email.toLowerCase().includes(searchTerm.toLowerCase()) || item.contactNo.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    });
  }, [filters, searchTerm, teamsDatas,filtersDate]);

  const DownloadCsv = async () => {
    if (teamsDatas?.length == 0) {
      toast.warn(`No ${tabName} Available`);
      return;
    }
    let arr = [];
    teamsDatas.map((row, i) => {
      arr.push([
        i + 1,
        row?.userName + "," + row?.email,
        row.contactNo ? FormatNigerianPhoneNumber(row.contactNo) : "-",
        row.baseAddress,
        row.state + "," + row.city,
        row.addedOn ? OnlyDateTimeConverter(row.addedOn) : "-",
        row.status,
      ]);
    });
    const csvheaderData = [
      ["Report Name", `${tabName} Table`],
      ["Report Genetated On: ", FormatDate(new Date().getTime())],
      [
        "S.No",
        "User Name",
        "Contact",
        "Base Address",
        "State / City",
        "Added On",
        "Status",
      ],
      ...arr,
    ];
    CsvDownload(csvheaderData, tabName);
  };

  const [profileIndex, setProfileIndex] = useState("");
  const [profileType, setProfileType] = useState("");

  const HandleAdminStatus = (type, i) => {
    if (type == "Active") {
      setProfileIndex(i);
      setOpenModal1(true);
      setProfileType(type);
    }
    else {
      setProfileIndex(i);
      setOpenModal(true);
      setProfileType(type);
    }
  };

  const HandleStatus = () => {
    if (profileType == "Active") {
      const newProfiles = teamsDatas.map((opt, i) =>
        i === profileIndex ? { ...opt, status: profileType } : opt
      );
      setTeamsDatas(newProfiles);
      setOpenModal1(false);
      toast.success(`${tabName} Activated Successfully`);
    }
    else {
      const newProfiles = teamsDatas.map((opt, i) =>
        i === profileIndex ? { ...opt, status: profileType } : opt
      );
      setTeamsDatas(newProfiles);
      setOpenModal(false);
      toast.success(`${tabName} Deactivated Successfully`);
    }
  }

  useEffect(() => {
    setTabValue(0);
    setTabName("Recruit Admin");
    setTeamsDatas(RecruitAdminDatas);
    setStaticsInfo(statics7dayData);
    setLegendDatas(legendData);
  }, []);

  return (
    <Grid item>
      {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ?
        <Grid item container justifyContent={"space-between"} className="mt-3">
          <Grid item container lg={3.9} md={12} sm={12} className="bg-white p-3 borderRadius10" flexDirection={"column"} alignItems={"flex-start"}>
            <Grid item container flexDirection={"column"}>
              <p className="Text-Prime-Green poppinsRegular text-left">Recruitment Admins</p>
              <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">{FormatAmount(staticsInfo?.recruitadmins)}</h4>
            </Grid>
            <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <PiewithScrollableLegend
              legendData={legendData}
              seriesData={seriesData}
              center={CenterDatas}
              height={"300px"}
              headingName={"Recruitment Admins"}
            />
          </Grid>
          <Grid item container lg={3.9} md={12} sm={12} className="bg-white p-3 borderRadius10" flexDirection={"column"} alignItems={"flex-start"}>
            <Grid item container flexDirection={"column"}>
              <p className="Text-Prime-Green poppinsRegular text-left">Field Agent Supervisor</p>
              <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">{FormatAmount(staticsInfo?.fieldagentsupervisors)}</h4>
            </Grid>
            <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <PiewithScrollableLegend
              legendData={legendData}
              seriesData={seriesData}
              center={CenterDatas}
              height={"300px"}
              headingName={"Field Agent Supervisor"}
            />
          </Grid>
          <Grid item container lg={3.9} md={12} sm={12} className="bg-white p-3 borderRadius10" flexDirection={"column"} alignItems={"flex-start"}>
            <Grid item container justifyContent={"space-between"}>
              <Grid item container lg={6} md={6} sm={12} flexDirection={"column"}>
                <p className="Text-Prime-Green poppinsRegular text-left">Field Agents</p>
                <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">{FormatAmount(staticsInfo?.fieldagents)}</h4>
              </Grid>
              <Grid item container marginTop={window.innerWidth > 768 ? 0 : 2} lg={6} md={6} sm={12} justifyContent={"flex-end"}>
                <CustomDropDown
                  placeholder={"All Field Agents"}
                  borderRadius={"8px"}
                  backgroundColor="#FFFFFF"
                  color="#2E3B47"
                  data={FieldAgentsOptions}
                  selected={
                    fieldagentChatDropdown && {
                      label: fieldagentChatDropdown,
                      value: fieldagentChatDropdown,
                    }
                  }
                  onChange={(e) => HandleFieldAgentChartDatas(e.value)}
                />
              </Grid>
            </Grid>
            <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
            <PiewithScrollableLegend
              legendData={legendDatas}
              seriesData={seriesData}
              center={CenterDatas}
              height={"300px"}
              headingName={"Field Agents"}
            />
          </Grid>
        </Grid>
        : ""}
      <Grid item container justifyContent={"space-between"} className="bg-white p-3 borderRadius10 mt-3">
        <Grid item container>
          {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ? (<>
            <TabsCustom value={tabValue} onChange={HandleTableChange} centered>
              <TabCustom label="Recruit Admin" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.recruitadmins)}</Avatar>} />
              <TabCustom label="Field Agent Supervisor" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.fieldagentsupervisors)}</Avatar>} />
              <TabCustom label="Field Agent - Data Entry" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.fieldagents)}</Avatar>} />
              <TabCustom label="Field Agent - Verification" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.finalizedapplicants)}</Avatar>} />
            </TabsCustom>
          </>) : (<>
            <TabsCustom value={tabValue} onChange={HandleTableChange} centered>
              <TabCustom label="Field Agent - Data Entry" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.fieldagents)}</Avatar>} />
              <TabCustom label="Field Agent - Verification" iconPosition="end" icon={<Avatar sx={{ backgroundColor: "#0FBE7C", width: "30px", height: "30px", fontSize: "12px" }}>{FormatAmount(staticsdayData?.finalizedapplicants)}</Avatar>} />
            </TabsCustom>
          </>)}

        </Grid>
        <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
        <Grid item container className="mt-3">
          <Grid item container lg={9.5} md={8} sm={12} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item container lg={2.4} md={3} sm={12}>
              <CustomInput
                placeholderColor={"#666666"}
                placeholder="Search By Name"
                backgroundColor="#FFFFFF"
                width={"100%"}
                maxLength={100}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                InputProps={<IoSearchOutline color="#666666" size={24} />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Grid>
            <Grid item container lg={1.8} md={2} sm={12}>
              <CustomDropDown
                placeholderColor={"#666666"}
                placeholder={"Filter by State"}
                borderRadius={"8px"}
                backgroundColor="#FFFFFF"
                color="#2E3B47"
                data={stateOptions}
                selected={
                  filters.state && {
                    label: filters.state,
                    value: filters.state,
                  }
                }
                onChange={(option) => HandleSelected("state", option)}
              />
            </Grid>
            <Grid item container lg={1.8} md={2} sm={12}>
              <CustomDropDown
                placeholderColor={"#666666"}
                placeholder={"Filter by City"}
                borderRadius={"8px"}
                data={cityOptions}
                selected={
                  filters.city && {
                    label: filters.city,
                    value: filters.city,
                  }
                }
                onChange={(option) => HandleSelected("city", option)}
              />
            </Grid>
            <Grid item container lg={2.8} md={3} sm={12}>
              <CustomDateInput
                placeholder="Filter by Date"
                color="#2E3B47"
                backgroundColor="#FFFFFF"
                width={"100%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                Value={dateRange}
                icon={<FiCalendar color="#666666" />}
                iconClick={() => setShowCalender(true)}
              />
            </Grid>
            <Grid item container lg={2.2} md={2} sm={12}>
              <CustomDropDown
                placeholder={"Filter by Status"}
                borderRadius={"8px"}
                data={statusOptions}
                selected={
                  filters.status && {
                    label: filters.status,
                    value: filters.status,
                  }
                }
                onChange={(option) => HandleSelected("status", option)}
              />
            </Grid>
          </Grid>
          <Grid item container lg={2.5} md={8} sm={12} justifyContent={"flex-end"}>
            {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ? (<>
              <GreenColorButton className="px-2 py-2" onClick={() => setAddProfileModal(true)}>Add New</GreenColorButton>
              <GreenColorButton className="px-0 py-2 ml-2" onClick={() => DownloadCsv()}><FaFileCsv color={"#FFFFFF"} size={24} /></GreenColorButton>
              <PrimeGrayColorButton className="px-0 py-2 ml-2" onClick={() => HandleRefresh()}><LuRefreshCcw color={"#FFFFFF"} size={24} /></PrimeGrayColorButton>
            </>) : (<>
              <GreenColorButton className="px-0 py-2 ml-2" onClick={() => DownloadCsv()}><FaFileCsv color={"#FFFFFF"} size={24} /></GreenColorButton>
              <PrimeGrayColorButton className="px-0 py-2 ml-2" onClick={() => HandleRefresh()}><LuRefreshCcw color={"#FFFFFF"} size={24} /></PrimeGrayColorButton>
            </>)}
          </Grid>
        </Grid>
        <Grid container lg={12} className="mt-3">
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell sx={{ width: "20%" }}>User Name</StyledTableCell>
                  <StyledTableCell>Contact</StyledTableCell>
                  <StyledTableCell sx={{ width: "20%" }}>Base Address</StyledTableCell>
                  <StyledTableCell>State / City</StyledTableCell>
                  <StyledTableCell>Added On</StyledTableCell>
                  <StyledTableCell align="center">Status</StyledTableCell>
                  {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ? (<>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </>) : ""}
                </StyledTableRow>
              </TableHead>
              {filteredAdmins.length > 0 ? (
                <TableBody>
                  {filteredAdmins.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                    <StyledTableRow key={i}>
                      <StyledTableCell align="left" className="pointer" role="presentation" onClick={() => HandleMap(row)}>
                        <p className="Text-DK-Green poppinsRegular">{row?.userName}</p>
                        <p className="Text-Prime-Gray poppinsRegular pt-1">{row?.email ? row?.email : "-"}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left" >
                        <p className="Text-Prime-Gray poppinsRegular">{row.contactNo ? FormatNigerianPhoneNumber(row?.contactNo) : "-"}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left" >
                        <p className="text-black poppinsRegular">{row?.baseAddress ? row?.baseAddress : "-"}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left" >
                        <p className="text-black poppinsRegular">{row?.state ? row?.state : "-"}</p>
                        <p className="Text-Prime-Gray poppinsRegular pt-1">{row?.city ? row?.city : "-"}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left" >
                        <p className="text-black poppinsRegular">
                          {row.addedOn ? OnlyDateTimeConverter(row.addedOn) : "-"}
                        </p>
                      </StyledTableCell>
                      <StyledTableCell align="center" >
                        <p className={StatusStyle(row.status)}>{row.status ? row.status : "-"}</p>
                      </StyledTableCell>
                      {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ? (<>
                        <StyledTableCell align="center">
                          {row?.status == "Active" ? <img src={InActiveIcon} role="presentation" className="img-fluid pointer" onClick={() => HandleAdminStatus("In Active", i)} alt="InActiveIcon" /> : <img src={CorrectIcon} role="presentation" className="img-fluid pointer" onClick={() => HandleAdminStatus("Active", i)} alt="CorrectIcon" />}
                        </StyledTableCell>
                      </>) : ""}
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <StyledTableCell colSpan={7} align="center">
                    <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                      <h5 className="text-black poppinsMedium mb-3">{`No ${tabName} Available to Display`}</h5>
                    </Grid>
                  </StyledTableCell>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          <Grid item container lg={12} justifyContent={"flex-end"}>
            {filteredAdmins.length > 10 ? (
              <CustomTablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={8}
                component="div"
                count={filteredAdmins.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={HandleChangePage}
                onRowsPerPageChange={HandleChangeRowsPerPage}
              />
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>
      <CustomModal
        open={showCalendar}
        setOpen={setShowCalender}
        modalTitle={<h4 className="poppinsSemiBold pt-2 text-black"> Select Date </h4>}
        width={"auto"}
        scrollable={false}
        modalContent={
          <Grid
            container
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <DateRangeSelector
              targetDate={calender}
              setDate={setCalender}
              isPast={true}
            />
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              className="mt-3"
            >
              <Grid item lg={3} container justifyContent={"flex-end"}>
                <PrimeGrayBorderColorButton
                  onClick={() => {
                    setCalender(null);
                    setShowCalender(false);
                  }}
                >CANCEL</PrimeGrayBorderColorButton>
              </Grid>
              <div className="p-2" />
              <Grid item lg={3}>
                <GreenColorButton
                  onClick={() => {
                    GetDateFormat();
                  }}
                >SUBMIT</GreenColorButton>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <CustomModal
        open={openModal}
        setOpen={setOpenModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">{`Do you want to deactivate this ${tabName}?`}</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setOpenModal(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleStatus()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={openModal1}
        setOpen={setOpenModal1}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">{`Do you want to activate this ${tabName}?`}</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setOpenModal1(false)}
            >
              No
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleStatus()}
            >
              Yes
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={editProfileModal}
        setOpen={setEditProfileModal}
        divider={false}
        header={true}
        modalTitle={<h4 className="poppinsMedium text-black">{`Edit ${tabName}`}</h4>}
        width={window.innerWidth > 600 ? "50%" : "95%"}
        modalContent={<Grid item container lg={12} md={12} sm={12} xs={12} flexDirection={"column"}>
          <Grid item container lg={12} xs={12} justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">First Name</p>
              <CustomInput
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                placeholder="Enter First Name"
                maxLength={80}
                value={sureName}
                onChange={(e) => setSureName(e.target.value)}
              />

            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Last Name</p>
              <CustomInput
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={80}
                placeholder="Enter Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Email Address</p>
              <CustomInput
                placeholder="Enter Email Address"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={100}
                value={email}
                disabled={true}
              />
            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Contact Number</p>
              <CustomInput
                placeholder="Enter Contact Number"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 2%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={12}
                type="number"
                value={phoneNumber}
                InputFrontProps={<p className="Text-Prime-Black poppinsMedium pr-2">+234</p>}
                InputProps={(<BiSolidPhone color={"#666666"} size={24} />)}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Base Address</p>
              <CustomDropDown
                placeholder={"Select Base Address"}
                borderRadius={"8px"}
                backgroundColor="#FFFFFF"
                color="#2E3B47"
                data={BaseAddressInfo}
                selected={
                  baseAddress && {
                    label: baseAddress,
                    value: baseAddress,
                  }
                }
                onChange={(e) => { setBaseAddress(e.value); setProfileCity(e.city); setProfileState(e.state); }}
              />
            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">State</p>
              <CustomInput
                placeholder="Enter your state"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={100}
                disabled={true}
                value={profileState}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">City</p>
              <CustomInput
                placeholder="Enter your City"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                disabled={true}
                maxLength={100}
                value={profileCity}
              />
            </Grid>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"flex-end"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => setEditProfileModal(false)}
            >
              Close
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleUpdateProfile()}
            >
              Update
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={sucessModal}
        setOpen={setSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <IoCheckmarkCircleOutline color={"#12A59B"} size={80} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">{`${tabName} Updated Successfully!`}</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => HandleSuccessModal()}
            >
              ok
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={addProfileModal}
        setOpen={setAddProfileModal}
        divider={false}
        header={true}
        closeIsActive={true}
        CloseModal={HandleCloseModal}
        modalTitle={<h4 className="poppinsMedium text-black">{`Add New ${tabName}`}</h4>}
        width={window.innerWidth > 600 ? "50%" : "95%"}
        modalContent={<Grid item container lg={12} md={12} sm={12} xs={12} flexDirection={"column"}>
          <Grid item container lg={12} xs={12} justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">First Name</p>
              <CustomInput
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                placeholder="Enter First Name"
                maxLength={80}
                value={addSureName}
                onChange={(e) => setAddSureName(e.target.value)}
              />

            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Last Name</p>
              <CustomInput
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={80}
                placeholder="Enter Last Name"
                value={addLastName}
                onChange={(e) => setAddLastName(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Email Address</p>
              <CustomInput
                placeholder="Enter Email Address"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={100}
                value={addEmail}
                onChange={(e) => setAddEmail(e.target.value)}
              />
            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Contact Number</p>
              <CustomInput
                placeholder="Enter Contact Number"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 2%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={12}
                type="number"
                value={addPhoneNumber}
                InputFrontProps={<p className="Text-Prime-Black poppinsMedium pr-2">+234</p>}
                InputProps={(<BiSolidPhone color={"#666666"} size={24} />)}
                onChange={(e) => setAddPhoneNumber(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">Base Address</p>
              <CustomDropDown
                placeholder={"Select Base Address"}
                borderRadius={"8px"}
                backgroundColor="#FFFFFF"
                color="#2E3B47"
                data={BaseAddressInfo}
                selected={
                  addBaseAddress && {
                    label: addBaseAddress,
                    value: addBaseAddress,
                  }
                }
                onChange={(e) => { setAddBaseAddress(e.value); setAddProfileCity(e.city); setAddProfileState(e.state); }}
              />
            </Grid>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">State</p>
              <CustomInput
                placeholder="Enter your state"
                fontSize={14}
                backgroundColor="#FFFFFF"
                disabled={true}
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                maxLength={100}
                value={addProfileState}
              />
            </Grid>
          </Grid>
          <Grid item container lg={12} xs={12} className="pt-3" justifyContent={"space-between"}>
            <Grid item container lg={5.8} md={5.8} sm={12} xs={12} flexDirection={"column"}>
              <p className="Text-Prime-Black poppinsMedium pb-2">City</p>
              <CustomInput
                placeholder="Enter your City"
                fontSize={14}
                backgroundColor="#FFFFFF"
                width={"100%"}
                height={"45px"}
                padding={"2.5% 3% 2.5% 0%"}
                border={"1px solid  #666666"}
                fontFamily={"PoppinsMedium"}
                disabled={true}
                maxLength={100}
                value={addProfileCity}
              />
            </Grid>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"flex-end"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => HandleCloseModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2 ml-2"
              onClick={() => HandleAddProfile()}
            >
              Add
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={addSucessModal}
        setOpen={setAddSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <IoCheckmarkCircleOutline color={"#12A59B"} size={80} />
          <p className="poppinsRegular Text-Prime-Black pt-3 text-center">{`New ${tabName} Added Successfully!`}</p>
          <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
            <DarkGreenColorButton
              type="submit"
              className="px-5 py-2"
              onClick={() => HandleAddSuccessModal()}
            >
              ok
            </DarkGreenColorButton>
          </Grid>
        </Grid>
        }
      />
    </Grid>
  );
};

export default Team;
